module.exports = __webpack_public_path__ + "static/media/aman_morghade.6fd5dbbf.png";